module.exports = __webpack_public_path__ + "img/linq.112dff6e.svg";